import { defineStore } from 'pinia'

const useSliderStore = defineStore('slider', {
  state: () => ({}),
  actions: {},
})

export default useSliderStore
